<!--page starts-->
<section class="page-wrapper">
    <div class="commercial-top-section margin-top-152 cf" style="background-image: url(assets/images/commercial-bg.jpg);">
        <div class="container">
            <div class="commercial-top-tab-list">
                <div class="commercial-top-tab-list-inner">
                    <div class="commercial-top-tab-list-detail">
                        <ul>
                            <li><a routerLink="/history" >History of LCCC</a></li>
                            <li><a routerLink="/museum" class="active">Museum</a></li>
                            <li><a routerLink="/honours">Honours</a></li>
                            <li><a routerLink="/records">Records</a></li>
                            <li><a routerLink="/ground">Ground Devlopments</a></li>                                 
                        </ul>
                    </div>
                    <div class="commercial-top-mouse">
                        <div class="commercial-top-mouse-img">
                            <img src="assets/images/mouse.svg">
                        </div>
                        <p>scroll for details</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-top-overlay">

        </div>
    </div>
    <div class="museum-center-section cf">
        <div class="container">
            <div class="museum-detail-section cf">
                <div class="museum-detail">
                    <div class="museum-hero-section cf">
                        <div class="museum-hero-left">
                            <div class="museum-hero-left-image">
                                <img [src]="museumList?.data?.image">
                            </div>
                        </div>
                        <div class="museum-hero-right">
                            <div class="titel-box">
                                <h2 class="titel-name">{{museumList?.data?.title}}</h2>
                            </div>
                            <div class="museum-hero-content" [innerHTML]="museumList?.data?.description">
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="museum-sub-committe-section cf" *ngIf="committeeList?.data">
                    <div class="titel-box">
                        <h2 class="titel-name">Sub-Committee Members</h2>
                    </div>
                    <div class="sub-committe-detail cf">
                        <div class="player-staff-box" *ngFor="let committe of committeeList?.data">
							<a href="#">
								<img [src]="committe?.image">
						     	<div class="player-staff-box-overlay">
									<h4>{{committe?.name}}</h4>
                                    <p>{{committe?.designation}}</p>
								</div>
                                <div class="player-staff-box-text" [innerHTML]="committe?.description">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                </div>
							</a>
						</div>
                        <!-- <div class="player-staff-box">
							<a href="#">
								<img src="assets/images/playe-img.png">
						     	<div class="player-staff-box-overlay">
									<h4>R. Holdridge</h4>
                                    <p>Hon. Archivist</p>
								</div>
                                <div class="player-staff-box-text">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                </div>
							</a>
						</div>
                        <div class="player-staff-box">
							<a href="#">
								<img src="assets/images/playe-img.png">
						     	<div class="player-staff-box-overlay">
									<h4>R. Holdridge</h4>
                                    <p>Hon. Archivist</p>
								</div>
                                <div class="player-staff-box-text">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                </div>
							</a>
						</div>
                        <div class="player-staff-box">
							<a href="#">
								<img src="assets/images/playe-img.png">
						     	<div class="player-staff-box-overlay">
									<h4>R. Holdridge</h4>
                                    <p>Hon. Archivist</p>
								</div>
                                <div class="player-staff-box-text">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                </div>
							</a>
						</div> -->
                    </div>
                </div>
                <div class="museum-content-section" [innerHTML]="museumList?.data?.members_description">
                    
                </div>
            </div>
        </div>
    </div>
</section><!-- page ends-->